var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.allowedRoutes),function(route){return _c('sidebar-item',{key:route.name,attrs:{"link":{name: route.title,
    path: route.path, icon: route.icon, customIcon: route.customIcon,
    disabled: route.notAllowedRoute }}},_vm._l((route.children),function(croute){return _c('sidebar-item',{key:croute.path,attrs:{"link":{name: croute.title, path: croute.path, disabled: croute.notAllowedRoute }}})}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Routing.vue